"use strict";

exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/dom-helpers@3.4.0/node_modules/dom-helpers/query/isWindow.js
// module id = 112
// module chunks = 0